module.exports = function(video) {
	"use strict";
  video
  .controller('videoTagEditController', videoTagEditController)
	videoTagEditController.$inject = ["$scope","$state","$stateParams","getDataService","refreshtokenService","$attrs","putDataService","alertService","$rootScope","serverError","offlineError"]
	
  function videoTagEditController($scope,$state,$stateParams,getDataService,refreshtokenService,$attrs, putDataService, alertService,$rootScope,serverError,offlineError) {
    var vmvte = this;
    $scope.parent = $scope.$eval($attrs.parent);
    vmvte.tagId = $scope.parent.tagId;
    vmvte.loadCategory= false;
    var state = 'video-tags'; 
    vmvte.disabled = true;
    $rootScope.closeEditVideoTag = function() {
      $scope.parent.tagEdit = false;
      vmvte.tag = null;
      $state.transitionTo('app.video_tags', {id: null}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    var getTagFunction = function() {
      $rootScope.hasLoaded = false;
      getDataService.get({param1:state, param2: vmvte.tagId}).$promise.then(function(data){
        $rootScope.hasLoaded = true;
        vmvte.tag = data;
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getTagFunction();
              }
            },
            function(error) {
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else {
          $scope.parent.tagEdit = false;
          $state.transitionTo('app.video_tags', {id: null}, {
            location: true,
            inherit: true,
            relative: $state.$current,
            notify: false
          });
        }
        $rootScope.hasLoaded = true;
      }); 
    }
    getTagFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/video-tag-edit/js/videoTagEditController.js
// module id = 655
// module chunks = 0